<template>
  <div class="g_detial">
    <p class="g_detialTop">
      <span @click="back"><img src="../../assets/images/users/Return.png"></span>
      <span>商品の詳細</span>
      <span></span>
    </p>

    <div class="detial_top">
      <div class="d_top_left">
        <img :src="goods_thumb.detail">
      </div>
      <div class="d_top_right">
        <p class="goods_name">{{goodDetail.goods_name}}</p>
        <p class="goods_brief">{{goodDetail.goods_brief}}</p>
        <div class="t_right_bottom">
          <div class="goods_key">商品価格</div>
          <div class="goods_value textColor">￥{{shopPrice}}(税込￥{{marketPrice}})</div>
        </div>
        <div class="t_right_bottom">
          <div class="goods_key">规格</div>
          <div class="goods_value">{{goodDetail.gmodel}}</div>
        </div>
        <div class="t_right_bottom RightNum">
          <div class="goods_collect" >
          </div>
          <div class="goods_value">
            <el-button plain @click="addCart">買い物かご</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="detial_center"></div>
    <div class="detial_bottom">
      <div class="d_buttom_left">
        <img :src="goods_thumb.detail11" height="450" width="260"/>
      </div>
      <div class="d_buttom_right">
        <table>
          <tr>
            <td>名&nbsp;&nbsp;&nbsp;&nbsp;称：</td>
            <td colspan="3">{{goodDecs.brand}}</td>
          </tr>
          <tr>
            <td>内&nbsp;容&nbsp;量：</td>
            <td colspan="3">{{goodDecs.standard}}</td>
          </tr>
          <tr>
            <td><span>原材料名：</span></td>
            <td colspan="3">{{goodDecs.raw_material}}</td>
          </tr>
          <tr>
            <td>賞味期限：</td>
            <td colspan="3">{{goodDecs.expiration_data}}</td>
          </tr>
          <tr>
            <td>お召し上がり方：</td>
            <td colspan="3">{{goodDecs.method}}</td>
          </tr>
          <tr>
            <td>保存方法：</td>
            <td colspan="3">{{goodDecs.save}}</td>
          </tr>
          <tr>
            <td>注&nbsp;&nbsp;&nbsp;&nbsp;意：</td>
            <td colspan="3">{{goodDecs.warn}}</td>
          </tr>
        </table>

      </div>
    </div>
    <div class="detial_Pbottom">
      <div class="detial_Pbottom_img">
        <img :src="goods_thumb.detail12" height="450" width="260"/>
      </div>
      <div class="detial_Pbottom_Message">
        <table>
          <tr>
            <td>名&nbsp;&nbsp;&nbsp;&nbsp;称：</td>
            <td colspan="3">{{goodDecs.brand}}</td>
          </tr>
          <tr>
            <td>内&nbsp;容&nbsp;量：</td>
            <td colspan="3">{{goodDecs.standard}}</td>
          </tr>
          <tr>
            <td><span>原材料名：</span></td>
            <td colspan="3">{{goodDecs.raw_material}}</td>
          </tr>
          <tr>
            <td>賞味期限：</td>
            <td colspan="3">{{goodDecs.expiration_data}}</td>
          </tr>
          <tr>
            <td>お召し上がり方：</td>
            <td colspan="3">{{goodDecs.method}}</td>
          </tr>
          <tr>
            <td>保存方法：</td>
            <td colspan="3">{{goodDecs.save}}</td>
          </tr>
          <tr>
            <td>注&nbsp;&nbsp;&nbsp;&nbsp;意：</td>
            <td colspan="3">{{goodDecs.warn}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {goodsDetail} from './../../api/interface/common'
  import {addCollectGoods, delCollectGoods, getCollectGoodsState, addCart} from './../../api/interface/users'
  export default{
    name: "goods_detial",
    data(){
      return {
        msg: 'hello vue',
        goods_number: 1,
//        collectstate: true,
        goodsSn: '',
        goodDetail: '',
        goodDecs: {},
        goods_id: '',
        collectState: '',
        limit_buy_min: 1,
        limit_buy_max: 10,
        goods_thumb: {},
        token: localStorage.getItem("token") || 0
      }
    },
    beforeMount(){
      $(window).scrollTop(0)
    },
    created(){
      this.getGoodsDetail();
    },
    computed: {
      marketPrice: function () {
        const num = parseFloat(this.goodDetail.market_price);
        num.toLocaleString();
        return num.toLocaleString();
      },
      shopPrice: function () {
        const num = parseFloat(this.goodDetail.shop_price);
        num.toLocaleString();
        return num.toLocaleString();
      }
    },
    methods: {
      back(){
        this.$router.go(-1)
      },
      //获取收藏商品状态
      getCollectGoodsState(){
        getCollectGoodsState(this.goods_id).then(result => {
          if (result.code === 1) {
            console.log(result);
            this.collectState = result.resData.collectNum;
            console.log(this.collectState);
          }
        }).catch(err => {
          console.log(err);
        })
      },
      //获取商品详细信息
      getGoodsDetail () {
          let that=this;
          that.goodDetail= JSON.parse(localStorage.getItem("goodsDetail"))
        that.goodDecs = that.goodDetail.goods_decs[0];
        that.goods_thumb =that.goodDetail.goods_thumb[0];

      },
      //获取购物车添加状态
      //添加到购物车
      addCart () {
        this.$router.push({path: "/404"})
      },
      //收藏取消商品
      collectGoods () {
        let goodsInfo = {
          goods_id: this.goods_id
        };
        if (this.collectState) {
          //取消收藏
          delCollectGoods(goodsInfo).then(result => {
            if (result.code === 1) {
              this.collectState = 0
            }
          }).catch(err => {
            if (err.code === 55) {
              console.log('操作对象不存在')
            }
          })

        } else {
          //添加收藏
          addCollectGoods(goodsInfo).then(result => {

            if (result.code === 1) {
              this.collectState = 1
            }
          }).catch(err => {
            console.log(err);
          })

        }
      },
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .g_detial {
      width: 100%;
      padding-bottom: 20px;
      position: relative;
      background-color: white;
      .g_detialTop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 50px;
        background-color: $TitColor;
        display: flex;
        justify-content: space-between;
        line-height: 50px;
        color: $whiteColor;
        z-index: 999;
        span:nth-child(1),
        span:nth-child(3) {
          width: 50px;
          display: inline-block;
          height: 50px;
          img {
            margin-top: 10px;
            margin-left: 10px;
          }
        }
      }
      .detial_top {
        width: 100%;
        padding: 0 1%;
        box-sizing: border-box;
        display: flex;
        margin: 50px auto 20px;
        padding-top: 10px;
        justify-content: space-between;
        font-size: $fontSize+rem;
        color: $fontColor;
        .d_top_left {
          width: 30%;
          img {
            height: 110/$default-w+rem;
            width: 100%;
            padding: 2px 5%;
            box-sizing: border-box;
          }
        }
        .d_top_right {
          width: 70%;
          .goods_name {
            height: 30/$default-w+rem;
            font-size: 16/$default-w+rem;
            font-weight: 500;
            border-bottom: 1px solid #000;
          }
          .goods_brief {
            font-size: 12px;
            word-break: break-all;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            color: $fontColor;
          }
          .t_right_bottom {
            height: 20px;
            margin-top: 5px;
            font-size: 13px;
            display: flex;
            .goods_key {
              width: 50%;
              /*float: left;*/
              line-height: 20px;
            }
            .goods_value {
              display: flex;
              align-items: center;
              float: right;
              font-size: 13px;
              line-height: 20px;
              button {
                /*font-size: 12px;*/
                border: none;
                outline: none;
                width: 110/$default-w+rem;
                max-width: 150px;
                height: 35px;
                text-align: center;
                color: #f6f7f9;
                font-size: 12/$default-w+rem;
                letter-spacing: $letter;
                background-color: $navcolor;
                border-radius: 5px;
              }
              .el-input-number--medium {
              width: 120/$default-w+rem;
              max-width: 150px;
              }

            }
            .goods_collect {
              width: 50%;
              height: 20px;
              padding: 7.5px 0;
              line-height: 20px;
              .collectIcon {
                float: left;
                height: 20px;
                width: 22px;
              }
              .collectText {
                height: 20px;
                float: left;
              }
            }
          }
          .button_num{
            height: 36px;
            width: 100%;
          }
          .RightNum {
            height: 35px;
            line-height: 35px;
          }
        }
      }
      .detial_center {
        height: 15px;
        width: 100%;
        margin: 30/$default-w+rem 0;
        background: $Footer_linear_ramp;
      }
      .detial_bottom {
        display: none;
      }
      .detial_Pbottom {
        width: 100%;
        .detial_Pbottom_img {
          img {
            width: 100%;
            height: 220/$default-w+rem;
          }
        }
        .detial_Pbottom_Message {
          tr {
            height: 20px;
            color: $fontColor;
            letter-spacing: 3px;
            td {
              font-size: $fontSize+rem;
              vertical-align: top;
            }
            td:nth-child(1) {
              height: 24px;
              text-align: center;
              width: 100px;
            }
            td:nth-child(3) {
              width: 80px;
              text-align: center;
            }
          }
        }
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .g_detial {
      width: 100%;
      max-width: 880px;
      margin: 50px auto 100px;
      position: relative;
      .g_detialTop {
        display: none;
      }
      .detial_top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: $fontColor;
        .d_top_left {
          width: 30%;
          img {
            height: 100%;
            width: 100%;
          }
        }
        .d_top_right {
          width: 60%;
          /*background-color: #eba898;*/
          .goods_name {
            height: 60px;
            line-height: 60px;
            font-size: 30px;
            font-weight: 400;
            border-bottom: 1px solid #000;
          }
          .goods_brief {
            height: 50px;
            font-size: 14px;
            line-height: 25px;
            color: $fontColor;
          }
          .t_right_bottom {
            margin-top: 20px;
            display: flex;
            font-size: 16px;
            line-height: 20px;
            .goods_key {
              flex: 1;
              .collectIcon {
                margin-top: 10px;
                float: left;
                height: 20px;
                width: 40px;
              }
              .collectText {
                margin-top: 10px;
                height: 20px;
                width: 70px;
                float: left;
              }
            }
            .goods_value {
              flex: 1;
              button {
                border: none;
                outline: none;
                width: 145px;
                height: 35px;
                padding: 5px 10px;
                text-align: center;
                color: #f6f7f9;
                letter-spacing: 2px;
                font-size: 18px;
                background-color: $navcolor;
                border-radius: 5px;
              }
              .el-input-number--medium {
                width: 150px;
              }
            }
            .textColor {
              color: $navcolor;
            }
            .goods_collect {
              width: 50%;
              float: left;
              height: 20px;
              padding: 7.5px 0;
              line-height: 20px;
              .collectIcon {
                float: left;
                height: 20px;
                width: 22px;
              }
              .collectText {
                height: 20px;
                float: left;
              }
            }
          }
          .success_tisi {
            z-index: 999;
            position: absolute;
            margin-top: 15px;
            color: $navcolor;
          }
          .t_right_name {
            display: inline-block;
            font-size: 30px;
            margin-bottom: 10px;
          }
          .t_right_explain {
            border-top: 1px solid $fontColor;
            line-height: 25px;
          }
        }
      }
      .detial_center {
        height: 15px;
        width: 100%;
        background: $Footer_linear_ramp;
        margin: 60px 0;
      }
      .detial_bottom {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .d_buttom_left {
          width: 30%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .d_buttom_right {
          width: 60%;
          height: 100%;
          tr {
            font-size: 16px;
            height: 45px;
            color: $fontColor;
            letter-spacing: 2px;
            /*position: relative;*/
            td {
              vertical-align: top;
            }
            td:nth-child(1) {
              text-align: right;
              width: 100px;
              position: relative;
              .stock {
                display: inline-block;
                width: 100px;
                height: 20px;
                position: absolute;
                margin-top: -50px;
                margin-left: -100px;
              }
            }
            td:nth-child(3) {
              width: 100px;
            }
          }
        }
      }
      .detial_Pbottom {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/goods_detial.vue